module.exports = __webpack_public_path__ + "img/SES_38069420.99317ef4.jpg";